/* ============================================================
   ALAYA JUNIOR — Header nav enhancement (Session 2 polish)
   Adds hover-intent open/close to the desktop mega-menu dropdowns.
   Dawn's <details>/<summary> are click-only by default; this layers
   pointer-driven open on top (desktop ≥ 990px only) while leaving
   click + keyboard behaviour intact for accessibility.
   ============================================================ */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';
  var OPEN_DELAY = 90; // ms intent delay before opening
  var CLOSE_DELAY = 180; // ms grace before closing

  function isDesktop() {
    return window.matchMedia && window.matchMedia(DESKTOP).matches;
  }

  function openDetails(details) {
    // Close any other open dropdown first (one at a time).
    document
      .querySelectorAll('.header__inline-menu details[open]')
      .forEach(function (other) {
        if (other !== details) closeDetails(other);
      });
    if (!details.hasAttribute('open')) details.setAttribute('open', '');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function closeDetails(details) {
    details.removeAttribute('open');
    var summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function init() {
    var items = document.querySelectorAll('.header__inline-menu header-menu');
    items.forEach(function (hm) {
      var details = hm.querySelector('details.mega-menu, details');
      if (!details) return;
      var openTimer, closeTimer;

      hm.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () {
          openDetails(details);
        }, OPEN_DELAY);
      });

      hm.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () {
          closeDetails(details);
        }, CLOSE_DELAY);
      });
    });

    // Close any open dropdown when focus/click leaves the nav entirely.
    document.addEventListener('click', function (e) {
      if (!isDesktop()) return;
      if (e.target.closest('.header__inline-menu')) return;
      document
        .querySelectorAll('.header__inline-menu details[open]')
        .forEach(closeDetails);
    });

    initDrawerSwipe();
  }

  /* ---- Mobile: swipe-left to close the full-screen drawer ----
     Delegates to Dawn's own close (summary click) so the drawer slides out to the
     left and the prior scroll position is restored — "back to where you were". */
  function initDrawerSwipe() {
    var container = document.querySelector('.menu-drawer-container');
    if (!container) return;
    var drawer = container.querySelector('.menu-drawer');
    if (!drawer) return;

    // Close helper — delegate to Dawn's summary so the drawer slides out to the
    // left and the prior scroll position is restored.
    function closeDrawer() {
      var summary = container.querySelector('summary');
      if (summary && container.hasAttribute('open')) summary.click();
    }

    // Explicit floating X inside the drawer (the header's own X is covered by the
    // full-screen drawer).
    var xBtn = drawer.querySelector('.js-drawer-close');
    if (xBtn) {
      xBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    }

    var startX = 0;
    var startY = 0;
    var tracking = false;

    drawer.addEventListener(
      'touchstart',
      function (e) {
        if (isDesktop() || !container.hasAttribute('open')) return;
        var t = e.changedTouches[0];
        startX = t.clientX;
        startY = t.clientY;
        tracking = true;
      },
      { passive: true }
    );

    drawer.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - startX;
        var dy = t.clientY - startY;
        // A deliberate leftward, predominantly-horizontal swipe closes the drawer.
        if (dx < -60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          closeDrawer();
        }
      },
      { passive: true }
    );
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
